const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    const err = new Error(payload?.error || 'Request failed.');
    err.code = payload?.code || null;
    throw err;
  }
  return payload;
}

export async function getStaff() {
  const res = await fetch(`${apiBase}/api/users/staff`);
  return handleResponse(res);
}

export async function inviteStaff({ firstName, lastName, email, role }) {
  const res = await fetch(`${apiBase}/api/users/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ firstName, lastName, email, role }),
  });
  return handleResponse(res);
}

export async function getLoginActivity(limit = 30) {
  const res = await fetch(`${apiBase}/api/activity/logins?limit=${limit}`);
  return handleResponse(res);
}

export async function resendStaffInvite(email) {
  const res = await fetch(`${apiBase}/api/auth/resend-welcome`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return handleResponse(res);
}
